const BASE_PATH = '/v1/consumer/product';

export const consumerProductRatingPath = (productId: number): string =>
  `${BASE_PATH}/${productId}/rating`;
